import React from 'react';
import {useMutation, useQuery} from 'react-query';
import {
  getById,
  getFolderContent,
  getFoldersByType,
  writeItem,
} from '../../api';
import {Clipboard, View} from 'react-native';
import {Button, Divider, IconButton, List} from 'react-native-paper';
import {ShopProductParams} from './paramseditor';
import {IShopConfig} from '../../types/shop';
import {
  connectToExchangeService,
  createSmartService,
  updateSmartServiceUserData,
} from '../../api/exchange';
import {ScrollView} from 'react-native-gesture-handler';
import {FolderType, MinimalProduct, Product} from '../../types';
export function ShopConfig(props: {
  shopId: string;
  mnemonic: string;
}) {
  const {shopId, mnemonic} = props;
  const configQuery = useQuery('shopconfig_' + shopId, async () => {
    const shopconfig = ((await getById(shopId)) || {
      id: shopId,
    }) as IShopConfig;
    if (shopconfig.address)
      shopconfig.service = await connectToExchangeService(
        shopconfig.address,
      );

    return shopconfig;
  });

  const config = configQuery.data!;

  const publishMutation = useMutation(async () => {
    console.info('publish smart service', config);
    try {
      if (!config.address) {
        console.info('creating smart service', config);
        const service = await createSmartService(config);
        config.address = service.contractAddress;
        await writeItem(config);
        config.service = service.contract;
      }
    } catch (err1) {
      console.error('error creating smart service', err1);
    }
    try {
      const folders = await getFolderContent(shopId);
      const products: MinimalProduct[] = (
        await Promise.all(
          folders.map(async i => {
            const content = (await getFolderContent(
              i.id,
            )) as Product[];
            return content.map(c => ({
              id: c.id,
              price: c.price,
              category: i.title,
              title: c.title || c.filename,
              description: c.productDescription || '',
              order: c.orderId,
              image: c.preview,
            }));
          }),
        )
      ).flat();
      console.info('products', products);
      try {
        if (!config.address) throw 'no_address';
        await updateSmartServiceUserData(
          config.address,
          products,
          config.title,
          config.logo,
          config.password,
        );
      } catch (err2) {
        console.error('error updating smart contract', err2);
      }
    } catch (err3) {
      console.error('err gathering products', err3);
    }
  });
  const onPublish = async () => publishMutation.mutateAsync();
  return (
    <View style={{width: '100%', height: '100%'}}>
      <ScrollView>
        <ShopProductParams<IShopConfig>
          product={config}
          productKey="title"
          title={'Name: '}
        />
        <ShopProductParams<IShopConfig>
          product={config}
          productKey="coin"
          title={'Coin: '}
        />
        <ShopProductParams<IShopConfig>
          product={config}
          productKey="preview"
          title={'Description: '}
        />
        <ShopProductParams<IShopConfig>
          product={config}
          productKey="ratings"
          title={'Ratings: '}
        />
        <ShopProductParams<IShopConfig>
          product={config}
          productKey="subsPrice"
          title={'Subscription Price: '}
        />
        <ShopProductParams<IShopConfig>
          product={config}
          productKey="operator"
          title={'Operator: '}
        />
        <ShopProductParams<IShopConfig>
          product={config}
          productKey="password"
          title={'Password: '}
        />
        <ShopProductParams<IShopConfig>
          product={config}
          productKey="category"
          title={'Category: '}
        />
        <ShopProductParams<IShopConfig>
          product={config}
          productKey="logo"
          title={'Logo: '}
          isFileSelector={true}
        />
        <Divider />
        <ShopProductParams<IShopConfig>
          left={
            config?.address
              ? () => (
                  <IconButton
                    onPress={() =>
                      Clipboard.setString(config?.address)
                    }
                    icon={'clipboard'}
                  />
                )
              : undefined
          }
          product={config}
          productKey="address"
          title={'Address: '}
          staticParam={true}
        />
      </ScrollView>
      <List.Item
        title={() => (
          <Button
            onPress={onPublish}
            loading={publishMutation.isLoading}
            disabled={publishMutation.isLoading}
            mode={'contained'}>
            {'Publish'}
          </Button>
        )}
      />
    </View>
  );
}
